/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import type { ReactNode } from 'react';
import { Icon, type IconName } from 'sarsaparilla';

import './SelectionCard.scss';

interface SelectionCardProps {
    id: string;
    label: string;
    /** Sarsaparilla icon name for simple icon display */
    icon?: IconName;
    /** Rich SVG illustration rendered inside the card */
    illustration?: ReactNode;
    isSelected: boolean;
    onSelect: () => void;
    className?: string;
}

function SelectionCard({
    id,
    label,
    icon,
    illustration,
    isSelected,
    onSelect,
    className = '',
}: SelectionCardProps) {
    const hasVisual = Boolean(icon) || Boolean(illustration);
    const selectedClass = isSelected ? 'wizard-selection-card--selected' : '';
    const textOnlyClass = !hasVisual ? 'wizard-selection-card--text-only' : '';

    return (
        <button
            id={id}
            type="button"
            className={`wizard-selection-card ${selectedClass} ${textOnlyClass} ${className}`.trim()}
            onClick={onSelect}
            aria-pressed={isSelected}
            data-ga-tracking-id="745757781454"
            data-ga-tracking-value={label}
        >
            {isSelected && (
                <span className="wizard-selection-card__check" aria-hidden="true">
                    <Icon iconName="check" />
                </span>
            )}
            {illustration && (
                <span className="wizard-selection-card__illustration" aria-hidden="true">
                    {illustration}
                </span>
            )}
            {icon && !illustration && (
                <span className="wizard-selection-card__icon" aria-hidden="true">
                    <Icon iconName={icon} size="lg" />
                </span>
            )}
            <span className="wizard-selection-card__label">{label}</span>
        </button>
    );
}

export default SelectionCard;
